<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <span style="font-weight: 700" class="text-uppercase">APP</span>
      <div style="float:right">
        <span class="dot-red"
              v-if="!channels[index].foreign_id || (channels[index].publish_later && !isPast(channels[index].publish_at))"
              content="Wird in der App nicht angezeigt" v-tippy></span>
        <span class="dot-green" content="Wird in der App angezeigt" v-else v-tippy></span>
      </div>
    </div>
    <div class="panel-body" v-if="record.client_has_app">
      <vue-toastr ref="toast"></vue-toastr>
      <div style="padding-bottom: 40px;" v-if="hasApp4">
        <label for="">Slidervorschaubild</label>
        <a class="fa fa-question-circle" v-tippy
           content="Das Bild muss im Format 4:5 vorliegen, mind. 1125x1406px oder höher. Die maximale Dateigröße bei Videos beträgt 10MB"></a>
        <content-preview :index="index" :scale-height="1452" :scale-width="1152"
                         :content-prop="{url: channels[index].preview_image_url, type: 'preview'}"
                         @update:channels="channelsUpdated"></content-preview>
      </div>
      <label for="">Beitragsbild</label>
      <a class="fa fa-question-circle" v-tippy
         content="Das Bild muss im Format 4:5 vorliegen, mind. 1125x1406px oder höher."></a>
      <content-preview :index="index"
                       :content-prop="{url: channels[index].content_url, type: 'content'}"
                       @update:channels="channelsUpdated"></content-preview>
      <br>
      <label>Teaser Text</label>
      <a class="fa fa-question-circle" v-tippy
         content="Steht direkt unter dem Vorschaubild in der App-News Listenansicht."></a>
      <div class="flex-column">
        <textarea class="form-control" v-model="channels[index].teaser_text"></textarea>
      </div>
      <div class="ckeditor-wrapper">
        <label>Content</label>
        <a class="fa fa-question-circle" v-tippy
           content="Hier können alle Infos zum News Beitrag stehen. Außerdem können Links eingefügt werden."></a>
        <ckeditor v-model="channels[index].news_content" :config="editorConfig"></ckeditor>
      </div>
      <br>
      <div class="form-group" v-if="hasApp4">
        <label for="test_user_ids">Testkundennummern</label>
        <a class="fa fa-question-circle" v-tippy
           content="Testaussendungen im Content-Hub sind erst ab der App-Version 4.1 möglich. Die Kundennummern sind durch Kommata getrennt. Die Testaussendung wird so lange in der App angezeigt wie die Anzeigedauer des Beitrags."></a>
        <input type="text" id="test_user_ids"
               class="form-control"
               v-model="channels[index].test_user_ids">
        <button class="btn btn-secondary btn-sm" style="margin-top: 10px" @click="sendToTestUsers">
          <i class="fa fa-share"></i>
          An Testkundennummern aussenden
        </button>
      </div>
      <div class="form-group">
        <input type="checkbox" :id="`has_expiration_date${channels[index].id}`"
               v-model="channels[index].has_expiration_date">
        <label :for="`has_expiration_date${channels[index].id}`">Ablaufdatum aktivieren</label>
      </div>
      <div class="form-group" v-if="channels[index].has_expiration_date">
        <label for="expiry_date">Ablaufdatum</label>
        <input type="datetime-local" v-model="channels[index].expiry_date" class="form-control">
      </div>
      <div class="form-group">
        <input type="checkbox" :id="`publish_later${channels[index].id}`" v-model="channels[index].publish_later">
        <label :for="`publish_later${channels[index].id}`">Später veröffentlichen</label>
      </div>
      <div class="form-group" v-if="channels[index].publish_later">
        <label for="publish_at">Veröffentlichungsdatum</label>
        <input type="datetime-local" v-model="channels[index].publish_at" id="publish_at" class="form-control">
      </div>
      <div class="panel panel-success" style="background: #d8ecff; padding: 10px">
        <b> Bitte beachten: </b> Nach dem Teilen des Posts können die Daten der Nachricht nicht mehr bearbeitet werden.
        Sie finden die erstellte Nachricht unter dem Menüpunkt Kampagnensteuerung 3.0 > Nachrichten.
      </div>
      <div class="form-group">
        <input type="checkbox" v-model="channels[index].send_push_notification" id="send_push_notification"
               :disabled="!newsHub.is_draft">
        <label for="send_push_notification">Push-Nachricht</label>
      </div>
      <div v-if="channels[index].send_push_notification">
        <label for="">Aussendungsart *</label>
        <select v-model="channels[index].send_push_notification_type" class="form-control"
                :disabled="disabled() || !newsHub.is_draft"
                required>
          <option value="">Auswählen</option>
          <option value="app_user_time">An alle App-User</option>
          <option value="selection">An Kunden aus smart.KIS Selektion</option>
        </select>
        <select v-model="channels[index].send_to_selection_id" class="form-control"
                style="margin-top: 5px"
                v-if="channels[index].send_push_notification_type === 'selection'"
                :disabled="disabled() || !newsHub.is_draft">
          <option value="" selected>Auswählen</option>
          <option v-for="selection in selections[newsHub.client_id]" :value="selection.id" :key="selection.id">
            {{ selection.name }}
          </option>
        </select>
        <div style="margin-top: 10px;" class="ckeditor-wrapper-app">
          <label for="">Text der Nachricht *</label>
          <textarea class="form-control" v-model="channels[index].push_notification"
                    :disabled="disabled() || !newsHub.is_draft"></textarea>
          <small>* Pflichtfeld</small>
          <div style="margin-top: 15px">
            <p v-if="channels[index].state === 14" style="color: green">Aussendung abgeschlossen</p>
            <p v-if="channels[index].state < 13" class="text-danger">Aussendung vorläufig</p>
            <p v-if="channels[index].state === 13" style="color: green">Aussendung gestartet</p>
          </div>
        </div>
      </div>
      <div class="form-group" v-if="hasApp4">
        <input type="checkbox" v-model="channels[index].filter_by_app_ids" id="filter_by_app_ids">
        <label for="filter_by_app_ids">Nach Apps filtern</label>
        <a class="fa fa-question-circle" v-tippy
           content="Ab App 4.1 verfügbar"></a>
      </div>
      <Select2 v-model="channels[index].app_ids" :options="apps" placeholder="Bitte auswählen"
               :settings="{multiple: true}" v-if="channels[index].filter_by_app_ids"/>
      <br>
      <button class="btn btn-sm btn-default" style="float:right" @click="deleteChannel"
              content="Aussendungskanal löschen" v-tippy>
        <i class="fa fa-trash-o" style="color: red"></i>
      </button>
    </div>
    <div class="panel-body" v-else>
      Es konnte keine App für Ihren Mandanten gefunden werden. <br> <br>
      <a class="btn btn-sm btn-success" href="mailto:info@hutter-unger.de?subject=App-Anfrage">App-Anfrage schicken</a>
      <button class="btn btn-sm btn-default" @click="deleteChannel" :disabled="!newsHub.is_draft"><i
          class="fa fa-trash-o"></i></button>
    </div>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import {mapGetters, mapMutations} from "vuex";
import {editorConfig} from "../editor/config";
import ContentPreview from "../image/ContentPreview";
import {isPast} from "../../services/checkIfPast";

export default {
  name: 'MobileApp',
  components: {ContentPreview, VueToastr},
  props: ['context', 'index', 'selections', 'newsHub', 'hasApp4'],
  data() {
    return {
      sendNotify: false,
      notifyCustomers: false,
      editorConfig: {
        instanceId: this.index,
        ...editorConfig,
        toolbar: [
          ['Styles', 'Format', 'Undo', 'Redo', 'Cut', 'Copy', 'Paste', 'Find', 'Replace', 'SelectAll', 'RemoveFormat'],
          ['Bold', 'Italic', 'Underline', 'Strike', 'NumberedList', 'BulletedList', 'EmojiPanel'],
          ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
          ['Link', 'Unlink', 'Image', 'Table', 'Maximize', 'Source']
        ]
      },
      editorConfigNotification: {
        toolbar: [
          "heading",
          "|",
          "Alignment",
          "fontFamily",
          "FontSize",
          "|",
          "FontColor",
          "fontBackgroundColor",
          "|",
          "Bold",
          "Italic",
          "Underline",
          "Strikethrough",
          "|",
          'undo',
          'redo',
        ]
      }
    }
  },
  methods: {
    isPast,
    channelsUpdated() {
      this.$forceUpdate()
    },
    ...mapMutations(['getChannels', 'removeChannel']),
    deleteChannel() {
      this.removeChannel({id: this.context.id, index: this.index})
      this.$refs.toast.s('Aussendungskanal gelöscht');
    },
    disabled() {
      return this.channels[this.index].state > 13
    },
    sendToTestUsers() {
      this.$parent.saveRecord('test_send');
    }
  },
  computed: {
    ...mapGetters({channels: 'getChannels', record: 'getRecord', selections: 'getSelections'}),
    apps() {
      // prepare options for Select2
      return this.record.client.apps.map(app => {
        return {id: app.id, text: app.name}
      })
    },
    customers() {
      return this.record.client.customers.map(customer => {
        return {id: customer.id, text: customer.full_name}
      })
    }
  },
  mounted() {
    this.notifyCustomers = !!this.channels[this.index].notify_via
  }
}
</script>

<style scoped>
.flex-column {
  display: flex;
  flex-direction: column;
}
</style>
<style>
.ckeditor-wrapper-app .ck-content {
  min-height: 100px;
}
</style>
